module.exports = __webpack_public_path__ + "img/wallpaper-7.e89c9f16.png";